// extracted by mini-css-extract-plugin
module.exports = {"icon":"socialIcon_icon__qhgnG","medium":"socialIcon_medium__Nm2MC","large":"socialIcon_large__xrMDP"};